module.exports = __webpack_public_path__ + "img/image_service_6.a943e748.png";